<!-- <div class="mr-2" *ngIf="showEducationDetails"> -->
  <div class="modal-body">
    <div class="row mb-4">
      <div class="col d-flex justify-content-between">
        <span class="font-weight-500">Education Details</span>
        <button data-testid="auto-app-education-modal-button-1" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <i class="fas fa-times f-14 text-black"></i>
      </button>
      </div>
    </div>
  <form [formGroup]="education_form">
    <div class="row">
      <div class="col">
        <div class="f-12 font-weight-500 mb-4"> Degree <span class="text-danger">*</span>
          <input data-testid="auto-app-education-modal-input-1" (input)="searchDegree($event)" type="text" placeholder="Enter Degree"
            #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
            class="wc-form-control nobg mt-1 text-capitalize" formControlName="degree" [matAutocomplete]="degree_auto" [ngClass]="{'border-red':education_form.get('degree').errors?.required && (education_form['controls'].degree.dirty || education_form['controls'].degree.touched) || education_form['controls'].degree.hasError('pattern')}">

          <mat-autocomplete #degree_auto="matAutocomplete">
            <mat-option *ngFor="let degree of degreelist" [value]="degree">
              {{degree}}
            </mat-option>
          </mat-autocomplete>

          <p *ngIf="education_form.get('degree').errors?.required && (education_form['controls'].degree.dirty || education_form['controls'].degree.touched)"
            [ngClass]="['text-left','my-1','text-danger']">Degree is required</p>
          <p *ngIf="education_form['controls'].degree.hasError('pattern') && (education_form['controls'].degree.dirty || education_form['controls'].degree.touched)" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
        </div>
      </div>
      <div class="col">

        <div class="f-12 font-weight-500 mb-4"> Name of School <span class="text-danger">*</span>

          <input data-testid="auto-app-education-modal-input-2" (input)="searchSchool($event)" type="text" placeholder="Enter Name of School"
            #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
            class="wc-form-control nobg mt-1 text-capitalize" formControlName="schoolname" [matAutocomplete]="school_auto" [ngClass]="{'border-red':education_form.get('schoolname').errors?.required && (education_form['controls'].schoolname.dirty || education_form['controls'].schoolname.touched) || education_form['controls'].schoolname.hasError('pattern')}">

          <mat-autocomplete #school_auto="matAutocomplete">
            <mat-option *ngFor="let school of schoollist" [value]="school">
              {{school}}
            </mat-option>
          </mat-autocomplete>
          <p *ngIf="education_form.get('schoolname').errors?.required && (education_form['controls'].schoolname.dirty || education_form['controls'].schoolname.touched)"
            [ngClass]="['text-left','my-1','text-danger']">School Name is required</p>
          <p *ngIf="education_form['controls'].schoolname.hasError('pattern') && (education_form['controls'].schoolname.dirty || education_form['controls'].schoolname.touched)" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="f-12 font-weight-500 mb-4"> Field of Study <span class="text-danger">*</span>
          <input data-testid="auto-app-education-modal-input-3" type="text" placeholder="Enter Field of Study" class="wc-form-control nobg mt-1"
            formControlName="fieldstudyname" [ngClass]="{'border-red':education_form.get('fieldstudyname').errors?.required && (education_form['controls'].fieldstudyname.dirty || education_form['controls'].fieldstudyname.touched) || education_form['controls'].fieldstudyname.hasError('pattern')}">
          <p *ngIf="education_form.get('fieldstudyname').errors?.required && (education_form['controls'].fieldstudyname.dirty || education_form['controls'].fieldstudyname.touched)"
            [ngClass]="['text-left','my-1','text-danger']">Field of Study is required</p>
          <p *ngIf="education_form['controls'].fieldstudyname.hasError('pattern')  && (education_form['controls'].fieldstudyname.dirty || education_form['controls'].fieldstudyname.touched)" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-6">
        <label class="f-12 font-weight-500 mb-1"> Start Year <span
            class="text-danger">*</span> </label>
        <div class="position-relative">
          <select data-testid="auto-app-education-modal-select-1" class="nobg wc-form-control position-relative z1" formControlName="startyear" [ngClass]="{'border-red':education_form.get('startyear').errors?.required && (education_form['controls'].startyear.dirty || education_form['controls'].startyear.touched) || education_form['controls'].startyear.hasError('pattern')}">
            <option [value]="null" disabled>Start Year</option>
            <option *ngFor="let x of year_list" [value]="x" selected>{{x}}</option>
          </select>
          <span class="selectdrop-down position-absolute  text-bluex topright1"><i
              class="far fa-calendar-minus f-14"></i> </span>
        </div>

        <p class="f-12 font-weight-500"
          *ngIf="education_form.get('startyear').errors?.required && (education_form['controls'].startyear.dirty || education_form['controls'].startyear.touched)"
          [ngClass]="['text-left','my-1','text-danger']">Start Year is required</p>
      </div>
      <div class="col-6">
        <label class="f-12 font-weight-500 mb-1"> End Year <span
            class="text-danger">*</span> </label>
        <div class="position-relative">
          <select data-testid="auto-app-education-modal-select-2" class="nobg wc-form-control position-relative z1" formControlName="endyear" [ngClass]="{'border-red':education_form.get('endyear').errors?.required && (education_form['controls'].endyear.dirty || education_form['controls'].endyear.touched) || education_form['controls'].endyear.hasError('pattern')}">
            <option [value]="null" disabled>End Year</option>
            <option *ngFor="let x of year_list" [value]="x" selected>{{x}}</option>
          </select>
          <span class="selectdrop-down position-absolute  text-bluex topright1"><i
            class="far fa-calendar-minus f-14"></i> </span>
        </div>
        <p class="f-12 font-weight-500"
          *ngIf="education_form.get('endyear').errors?.required && (education_form['controls'].endyear.dirty || education_form['controls'].endyear.touched)"
          [ngClass]="['text-left','my-1','text-danger']">End Year is required</p>
      </div>
    </div>
    <p class="f-12 font-weight-500"
    *ngIf="education_form['controls'].endyear.hasError('incorretEducationYear')"
    [ngClass]="['text-left','my-1','text-danger']">End year should be greater than start year.</p>
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-education-modal-button-2" type="button" class="btn-trms-small" data-dismiss="modal" [disabled]="addEducationSpinner"
          (click)="addeducation()">
         <span [ngClass]="{ 'spinner-border text-light spinner-size': addEducationSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addEducationSpinner }">
          {{addEducationSpinner ? '' : 'Save'}}
        </span>
        </button>
      </div>
    </div>
  </form>
  </div>
<!-- </div>  -->
